import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import { ArticleItem } from '@domains/article';

import { ARTICLE_TYPES } from '@utils/constants';
import { makeNewsDetailsRoute } from '@utils/route';

import { ArticleDatesRange } from '@components/article/ArticleDatesRange/ArticleDatesRange';
import { Link } from '@components/common/Link/Link';
import { Picture } from '@components/common/Picture/Picture';
import { NoImageIcon } from '@components/icons';

import styles from './ArticleCard.module.scss';

type ArticleCardProps = ArticleItem & {
    className?: string;
};
export const ArticleCard: FunctionComponent<ArticleCardProps> = (props) => {
    const { type, thumbnail, title, dates, slug, className } = props;

    return (
        <article className={clsx(styles.root, className)}>
            <div className={styles.imageContainer}>
                {thumbnail !== null ? (
                    <Picture sources={thumbnail} alt={title} className={styles.image} />
                ) : (
                    <NoImageIcon className={styles.image} />
                )}
                <div className={styles.badge}>{ARTICLE_TYPES[type]}</div>
            </div>
            <span className={styles.date}>
                <ArticleDatesRange dates={dates} type={type} />
            </span>
            <Link route={makeNewsDetailsRoute(slug)} className={styles.link}>
                <h3 className={styles.title} dangerouslySetInnerHTML={{ __html: title }}></h3>
            </Link>
        </article>
    );
};
